<div class="container">
        <div *ngIf="!isLoading">
    
            <div class="facebook-actions">
              <a href="https://www.facebook.com/marketplace/create/item" target="_blank" mat-raised-button>List</a>
              <button mat-raised-button (click)="generateDefaults()">Fill Defaults</button>
            </div>

            <mat-form-field appearance="outline">
                <mat-label>Facebook Title</mat-label>
                <input matInput [(ngModel)]="item.facebook.title" (blur)="save()">
            </mat-form-field>
        
            <mat-form-field appearance="outline">
                <mat-label>Facebook Content</mat-label>
                <textarea matInput
                            [(ngModel)]="item.facebook.description"
                            cdkTextareaAutosize
                            #autosize="cdkTextareaAutosize"
                            cdkAutosizeMinRows="10"
                            cdkAutosizeMaxRows="50"
                            (blur)="save()"></textarea>
                </mat-form-field>
        
            <mat-form-field appearance="outline">
                <mat-label>Facebook URL</mat-label>
                <input matInput [(ngModel)]="item.facebook.url" (blur)="save()">
                <mat-hint><a target="_blank" [href]="item.facebook.url">{{item.facebook.url}}</a></mat-hint>
            </mat-form-field>
        </div>    
    </div>